const readPrerenderQuery = () => {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('__prerender') === '1';
};

export const isPrerendering = () => {
  if (typeof window === 'undefined') return false;
  return window.__PRERENDERING__ === true || readPrerenderQuery();
};

export const getPrerenderMode = () => isPrerendering();

export const resetPrerenderReady = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.__PRERENDER_READY__ = false;
  delete document.documentElement.dataset.prerenderReady;
};

export const markPrerenderReady = pageType => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.__PRERENDER_READY__ = true;
  document.documentElement.dataset.prerenderReady = pageType;
};

